"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columns = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var columns = function columns(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'columns-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M3.49994 6.11908C3.49994 5.74698 3.49994 5.56092 3.5445 5.40917C3.64996 5.04999 3.93085 4.7691 4.29003 4.66364C4.44178 4.61908 4.62783 4.61908 4.99994 4.61908C5.37204 4.61908 5.55809 4.61908 5.70984 4.66364C6.06903 4.7691 6.34992 5.04999 6.45538 5.40917C6.49994 5.56092 6.49994 5.74698 6.49994 6.11908V15.1191C6.49994 15.4912 6.49994 15.6772 6.45538 15.829C6.34992 16.1882 6.06903 16.4691 5.70984 16.5745C5.55809 16.6191 5.37204 16.6191 4.99994 16.6191C4.62783 16.6191 4.44178 16.6191 4.29003 16.5745C3.93085 16.4691 3.64996 16.1882 3.5445 15.829C3.49994 15.6772 3.49994 15.4912 3.49994 15.1191V6.11908Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M8.49994 6.11908C8.49994 5.74698 8.49994 5.56092 8.5445 5.40917C8.64996 5.04999 8.93085 4.7691 9.29003 4.66364C9.44178 4.61908 9.62783 4.61908 9.99994 4.61908C10.372 4.61908 10.5581 4.61908 10.7098 4.66364C11.069 4.7691 11.3499 5.04999 11.4554 5.40917C11.4999 5.56092 11.4999 5.74698 11.4999 6.11908V15.1191C11.4999 15.4912 11.4999 15.6772 11.4554 15.829C11.3499 16.1882 11.069 16.4691 10.7098 16.5745C10.5581 16.6191 10.372 16.6191 9.99994 16.6191C9.62783 16.6191 9.44178 16.6191 9.29003 16.5745C8.93085 16.4691 8.64996 16.1882 8.5445 15.829C8.49994 15.6772 8.49994 15.4912 8.49994 15.1191V6.11908Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M13.4999 6.11908C13.4999 5.74698 13.4999 5.56092 13.5445 5.40917C13.65 5.04999 13.9309 4.7691 14.29 4.66364C14.4418 4.61908 14.6278 4.61908 14.9999 4.61908C15.372 4.61908 15.5581 4.61908 15.7098 4.66364C16.069 4.7691 16.3499 5.04999 16.4554 5.40917C16.4999 5.56092 16.4999 5.74698 16.4999 6.11908V15.1191C16.4999 15.4912 16.4999 15.6772 16.4554 15.829C16.3499 16.1882 16.069 16.4691 15.7098 16.5745C15.5581 16.6191 15.372 16.6191 14.9999 16.6191C14.6278 16.6191 14.4418 16.6191 14.29 16.5745C13.9309 16.4691 13.65 16.1882 13.5445 15.829C13.4999 15.6772 13.4999 15.4912 13.4999 15.1191V6.11908Z',
    fill: '#4B5563'
  }));
};

exports.columns = columns;